// extracted by mini-css-extract-plugin
module.exports = {"container":"F-example-container-2pGKr"};